import apiClientServices from "../../../../api-client";
import { SessionStorageExistence } from "./storage";
const measureAPITime = () => {
    const startTime = performance.now();
    // Make your API call here
    apiClientServices
        .get("")
        .then(response => {
        const endTime = performance.now();
        const timeTaken = endTime - startTime;
        saveInternetSpeedToSessionStorage(timeTaken);
    })
        .catch(error => {
        // Handle error
    });
};
function calculateInternetSpeedStability(responseTime) {
    if (responseTime < 100) {
        return "Very Stable";
    }
    else if (responseTime < 200) {
        return "Stable";
    }
    else if (responseTime < 500) {
        return "Moderate";
    }
    else if (responseTime < 1000) {
        return "Unstable";
    }
    else {
        return "Very Unstable";
    }
}
const saveInternetSpeedToSessionStorage = (avgAPIResponseTime) => {
    let frontendLogs = [];
    let logStorage = SessionStorageExistence("logs");
    const log = {
        avgAPIResponseTime,
        internetSpeedStability: calculateInternetSpeedStability(avgAPIResponseTime),
    };
    if (logStorage.isExist) {
        frontendLogs = logStorage.data;
    }
    frontendLogs.push(log);
    sessionStorage.setItem("logs", JSON.stringify(frontendLogs));
};
export const getInternetSpeed = (saveLogs = true, intervalDuration = 0.1 * 60 * 1000) => {
    let timeoutId;
    const measureInternetSpeed = () => {
        measureAPITime();
        if (!saveLogs) {
            timeoutId = setTimeout(measureInternetSpeed, intervalDuration);
        }
    };
    measureInternetSpeed();
    return () => {
        clearTimeout(timeoutId);
    };
};
